<template>
  <StakeholdersInformUsers
    ref="component"
    :period-id="periodId"
    @set-loader="$emit('set-loader', $event)"
    @subtitle="setSubtitle"
    @make-count-0="$emit('make-count-0')"
  />
</template>

<script>
import { setSubtitle } from '@/reusable/workflow/task-modals/modals-shared'
// Components
import StakeholdersInformUsers from '../components/stakeholders-inform-users/StakeholdersInformUsers'

export default {
  components: {
    StakeholdersInformUsers
  },

  props: {
    periodId: [Number, String]
  },

  methods: {
    setSubtitle: setSubtitle('Subscriptions'),

    getCount() {
      return this.$refs.component.getCount()
    }
  }
}
</script>
